import { createContext } from 'react'
import type { IBreadcrumb } from '@/components/ui/Breadcrumbs/Breadcrumb/interfaces'
import { agroservicesBreadcrumb } from '@/components/ui/Breadcrumbs/constants'
import type { IFaqContext } from './types'

export const breadcrumbs: IBreadcrumb[] = [agroservicesBreadcrumb, { captionId: 'faq.breadcrumb', link: '/faq' }]

export const FaqContext = createContext<IFaqContext>({} as IFaqContext)
